
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';
// Components
import BaseComponent from './BaseComponent.vue';
// Components
import { SnackBarItem } from '@/store/index';

/**
 * Snack Bar複数表示コンポーネント
 */
@Component
export default class SnackBars extends Mixins<BaseComponent>(BaseComponent) {
  get snackBars() {
    return this.store.snackBars;
  }

  private onClick(snackbar: SnackBarItem) {
    this.store.hideMessage(snackbar.id);
  }
}
